import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@visurel/iconify-angular';
import { MaterialShared } from '../shared/material-shared.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { EmployerSignupComponent } from './employer-signup/employer-signup.component';
import { ConfirmSignatureComponent } from './confirm-signature/confirm-signature.component';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../shared/shared.module';
import { SignContractComponent } from './sign-contract/sign-contract.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { BriefingComponent } from './briefing/briefing.component';
import { AboutComponent } from './about/about.component';
import { BriefingDetailsComponent } from './briefing-details/briefing-details.component';
import { OtpInputComponent } from './login/otp-input/otp-input.component';
import { PublicDocumentUploadComponent } from './public-document-upload/public-document-upload.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
  },
  {
    path: 'employer-signup',
    component: EmployerSignupComponent,
  },
  {
    path: 'briefing/:id',
    component: BriefingComponent,
  },
  {
    path: 'briefing/about/:id',
    component: AboutComponent,
  },
  {
    path: 'briefing/about/form/:id',
    component: BriefingDetailsComponent,
  },
  {
    path: 'public-document-upload/:calluid',
    component: PublicDocumentUploadComponent,
  },
];

@NgModule({
  declarations: [LoginComponent, ForgotPasswordComponent, ChangePasswordComponent, EmployerSignupComponent, ConfirmSignatureComponent, SignContractComponent, BriefingComponent, AboutComponent, BriefingDetailsComponent, OtpInputComponent, PublicDocumentUploadComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconModule,
    MaterialShared,
    RouterModule.forChild(routes),
    // PdfViewerModule,
    SharedModule,
    NgOtpInputModule
  ],
  entryComponents: [ConfirmSignatureComponent, SignContractComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class PublicModule { }
